import { Injectable } from '@angular/core';
import {State, Action, StateContext, Selector} from '@ngxs/store';
import {storeSchedulerAction, storeTypeAction} from './scheduler.action'
export class storeSchedulerModel{
    //schedulerObjData:any[]
    sampleVariable: number;
    type: string;
}
 @State<storeSchedulerModel>({
     name: 'schedulerObj',
     defaults: {
        sampleVariable:0,
        type:null
        //schedulerObjData:[]
      }
 })
 @Injectable()
 export class storeSchedulerState {
 
     constructor( ) {
     }
 
     @Selector()
     static getschedulerObj(state: storeSchedulerModel) {
         return state;
     }
     @Action(storeSchedulerAction)
     storeSchedulerAction({getState, patchState}: StateContext<storeSchedulerModel>, {payload}: storeSchedulerAction) {
         const state = getState();
         
         patchState({
            sampleVariable:payload,
            //schedulerObjData:[...state.schedulerObjData,payload]
         });
     }

     @Action(storeTypeAction)
     storeTypeAction({getState, patchState}: StateContext<storeSchedulerModel>, {payload}: storeTypeAction) {
         const state = getState();
         
         patchState({
            type:payload,
            //schedulerObjData:[...state.schedulerObjData,payload]
         });
     }
    } 